<template>
  <div class="trustpilot-block">
    <div class="trustpilot-block__header">
      <img src="../../../../assets/img/trustpilot-block.svg" alt="" class="trustpilot-block__image">
      <img src="../../../../assets/img/logos/skov-rejser-dk-logo-purple.webp" alt="Skovrejser.dk logo" class="trustpilot-block__skovrejser-logo">
    </div>
    <div class="trustpilot-block__text">
      <slot></slot>
    </div>
    <div class="trustpilot-block__widget">
    </div>
    <div class="trustpilot-block__cta">
      <button class="btn btn--positive" v-text="translations.search_btn_txt" @click="scrollToTop"></button>
    </div>
  </div>
</template>

<script>
import { scrollTo } from 'scroll-js';

export default {
  methods: {
    scrollToTop() {
      scrollTo(document.body, { top: 0 });
    }
  },
  computed: {
    translations() {
      return APP_CONFIG.TRANSLATION.FRONTPAGE_TRUSTPILOT;
    }
  }
};
</script>